import * as z from 'zod'

import {
  cashFlowList,
  investorList,
  markList,
  optionalText,
  requiredAmount,
  requiredDate,
  requiredText,
  tagList,
  withEntities,
} from '../utils/schema'

export const privateFundSchema = withEntities(
  z.object({
    assetName: requiredText('Name this fund'),
    description: optionalText(),
    amount: requiredAmount('Enter the committed amount'),
    date: requiredDate('Enter the date of investment'),
    currency: optionalText(),
    /*
     * More than one entity may each hold this same fund position — see
     * WizardInvestor. Each becomes its own asset-and-transaction bundle, for
     * the full amount above — never a share of it, unlike
     * PrivateFundSubscribeAndCommit's own `investors`.
     */
    investors: investorList(),
    /* What the valuation step recorded, if anything. See markList. */
    prices: markList(),
    /* Capital calls, fees and distributions, if any. See cashFlowList. */
    cashFlows: cashFlowList(),
    tags: tagList(),
  }),
)

export type PrivateFundValues = z.infer<typeof privateFundSchema>
